import { Box, Hidden, Typography } from '@mui/material';
import ReadMore from './ReadMore';

interface PageInformation {
  segmentationIntro: {
    title: string;
    description: string;
  };
}

const PageInfo = ({ segmentationIntro }: PageInformation) => {
  return (
    <Box my={4}>
      <Typography
        variant="h2"
        color="primary"
        mb={3}
        lineHeight="28px"
        fontWeight="400"
        textAlign={{ xs: 'center', sm: 'left' }}>
        {segmentationIntro.title}
      </Typography>
      <Hidden implementation="css" smUp>
        <ReadMore
          gutterBottom
          color="textPrimary"
          component="div"
          variant="body2"
          charLimit={155}
          value={segmentationIntro.description}
          showMoreLabel="more"
        />
      </Hidden>
      <Hidden implementation="css" smDown>
        <Typography variant="body2" color="textPrimary">
          {segmentationIntro.description}
        </Typography>
      </Hidden>
    </Box>
  );
};

export default PageInfo;
